"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            course: null,
            submitting: false,
            showPosterPlus: false,
            searchResults: [],
            suggestions: [],
            byPackages: false,
            showScheduleForm: false,
            showPrerequisiteForm: false
        };
        GState.bind(this, [
            'tenant',
            'user'
        ]);
        this.fhandler = new FormHandler({
            key: 'edit-course',
            autosave: true
        });
        this.fhandler.bind(this);
    },
    onMount: function () {
        this.getCourse();
        const title = 'Editing Course';
        this.fhandler.on('autosave', () => GState.activity.add({
            title,
            path: '/edit-course/' + this.courseId
        })).on('reset', () => GState.activity.remove(title));
    },
    onCall: function (...arg) {
        this.emit('call', ...arg);
    },
    onSelectPoster: function (status) {
        this.state.showPosterPlus = status || false;
    },
    onSetPoster: function ({base64, src}) {
        if (!src)
            return;
        this.fhandler.set('poster', base64 || src);
        this.state.showPosterPlus = false;
    },
    addCategory: function (categoryId, name) {
        const categories = this.state.form.categories || [];
        if (categories.length && categories.filter(each => {
                return each.categoryId == categoryId;
            }).length)
            return;
        categories.push({
            categoryId,
            name
        });
        this.fhandler.set('categories', categories);
    },
    removeCategory: function (categoryId) {
        this.fhandler.set('categories', this.state.form.categories.filter(each => {
            return each.categoryId !== categoryId;
        }));
    },
    onByPackages: function (e) {
        this.state.byPackages = e.target.checked;
        if (!e.target.checked)
            delete this.state.form.packages;
    },
    addPackage: function (type) {
        const packages = this.state.form.packages || [];
        if (packages.includes(type))
            return;
        packages.push(type);
        this.fhandler.set('packages', packages);
    },
    addAllPackage: function (packages) {
        this.fhandler.set('packages', packages);
    },
    removePackage: function (type) {
        this.fhandler.set('packages', this.state.form.packages.filter(each => {
            return each !== type;
        }));
    },
    onModalForm: function (type, status) {
        this.state['show' + type + 'Form'] = status;
    },
    removeSchedule: function (index) {
        this.fhandler.set('schedules', this.state.form.schedules.filter((each, i) => {
            return i != index;
        }));
    },
    removePrerequisite: function (index) {
        this.fhandler.set('prerequisites', this.state.form.prerequisites.filter((each, i) => {
            return i != index;
        }));
    },
    onSearchResult: function (results) {
        this.state.searchResults = results;
        this.state.suggestions = results.map(({profile, account}) => {
            return {
                poster: {
                    type: 'image',
                    value: profile.photo
                },
                title: getFullname(profile),
                subtitle: profile.email
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
        const {profile, instructor} = this.state.searchResults[index];
        if (!instructor || isEmpty(instructor)) {
            this.fhandler.alert(getFullname(profile) + ' is not an instructor', 'warning');
            return;
        }
        const isAdded = this.instructors.filter(({email}) => {
            return profile.email == email;
        }).length;
        if (isAdded)
            return;
        this.instructors.push({
            photo: profile.photo,
            name: getFullname(profile),
            email: profile.email,
            title: instructor.title,
            departments: instructor.department
        });
        this.fhandler.set('instructors', this.instructors);
    },
    onSelectSuggestionAlt: function (index, {href}) {
        href && navigate(href);
    },
    removeInstructor: function (arg) {
        this.instructors = this.instructors.filter(({email}) => {
            return email !== arg;
        });
        this.fhandler.set('instructors', this.instructors);
    },
    getCourse: async function () {
        try {
            const {error, message, course} = await Request('/course/' + this.input.params.id);
            if (error)
                return console.log('Error Fetching Course: ', message);
            this.state.course = course;
            const {courseId, name, description, poster, code, points, price, categories, availability, difficultyLevel, multiLanguage, about, prerequisites, objectives, policy, readings, instructors, schedules, packages} = course;
            this.instructors = instructors || [];
            this.courseId = courseId;
            if (packages && packages.length)
                this.state.byPackages = true;
            this.fhandler.fill({
                courseId,
                name,
                description,
                poster,
                code,
                points,
                price,
                categories,
                availability,
                difficultyLevel,
                multiLanguage,
                about,
                prerequisites,
                objectives,
                policy,
                readings,
                instructors,
                schedules,
                packages
            });
        } catch (error) {
            console.log('Error Fetching Course', error);
            this.state.course = false;
        }
    },
    onSubmit: async function () {
        const Form = this.state.form;
        if (!Form.name)
            return this.state.formError.name = true;
        if (!Form.description)
            return this.state.formError.description = true;
        this.state.submitting = true;
        try {
            const {error, message} = await Request('/course/update/' + this.courseId, 'PUT', Form);
            this.state.submitting = false;
            this.fhandler.alert(message, error ? 'error' : 'success');
            if (error)
                return;
            this.fhandler.reset();
            setTimeout(() => navigate('/course/' + this.courseId), 3000);
        } catch (error) {
            this.state.submitting = false;
            this.fhandler.alert(error);
        }
    },
    onCancel: function () {
        this.fhandler.reset();
        navigate(`/course/${ this.courseId }`);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Courses/create/Edit.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    LoadingPage_template = require("../../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    EmptyList_template = require("../../../components/EmptyList.marko"),
    EmptyList_tag = marko_loadTag(EmptyList_template),
    PosterInput_template = require("../../../components/PosterInput.marko"),
    PosterInput_tag = marko_loadTag(PosterInput_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    SelectCategory_template = require("../../../components/SelectCategory.marko"),
    SelectCategory_tag = marko_loadTag(SelectCategory_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Select_template = require("../../../../components/Select/index.marko"),
    Select_tag = marko_loadTag(Select_template),
    PriceInput_template = require("../../../components/PriceInput.marko"),
    PriceInput_tag = marko_loadTag(PriceInput_template),
    _preserve_tag = marko_loadTag(require("marko/dist/core-tags/components/preserve-tag")),
    SelectPackage_template = require("../../../components/SelectPackage.marko"),
    SelectPackage_tag = marko_loadTag(SelectPackage_template),
    Schedules_template = require("../../../components/Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    QuillEditor_template = require("../../../../components/QuillEditor/index.marko"),
    QuillEditor_tag = marko_loadTag(QuillEditor_template),
    Card_Accordion_template = require("../../../components/Card-Accordion/index.marko"),
    Card_Accordion_tag = marko_loadTag(Card_Accordion_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Image_template = require("../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    SearchBar_template = require("../../../../components/SearchBar/index.marko"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    FormAlert_template = require("../../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    PrerequisiteForm_template = require("../../../components/PrerequisiteForm.marko"),
    PrerequisiteForm_tag = marko_loadTag(PrerequisiteForm_template),
    ScheduleForm_template = require("../../../components/ScheduleForm/index.marko"),
    ScheduleForm_tag = marko_loadTag(ScheduleForm_template),
    PosterPlus_template = require("../../../../components/PosterPlus/index.marko"),
    PosterPlus_tag = marko_loadTag(PosterPlus_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "row m-0"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("e7f07a"),
    marko_node0 = marko_createElement("br", null, "23", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "form-group"
      },
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_node1 = marko_createElement("br", null, "42", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "mb-3"
      },
    marko_attrs4 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs5 = {
        "for": "multi-language",
        "class": "font-medium-1"
      },
    marko_attrs6 = {
        href: "/terms"
      },
    marko_attrs7 = {
        "class": "mt-2"
      },
    marko_node2 = marko_createElement("br", null, "76", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "77", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "col-md-4 col-12 pr-md-0 mb-md-0 mb-4"
      },
    marko_attrs9 = {
        "class": "col pl-6"
      },
    marko_attrs10 = {
        "class": "form-group"
      },
    marko_attrs11 = {
        "class": "form-group pt-2"
      },
    marko_attrs12 = {
        "class": "font-medium-2"
      },
    marko_attrs13 = {
        "class": "list-inline"
      },
    marko_attrs14 = {
        "class": "mr-2"
      },
    marko_attrs15 = {
        "class": "chip theme-bg-lighten rounded"
      },
    marko_attrs16 = {
        "class": "chip-body font-medium-2"
      },
    marko_attrs17 = {
        "class": "chip-text py-50"
      },
    marko_attrs18 = {
        "class": "chip-closeable p-50 m-50"
      },
    marko_attrs19 = {
        "class": "bx bx-x white-text"
      },
    marko_attrs20 = {
        "class": "col-md-6 col-12"
      },
    marko_attrs21 = {
        "class": "form-group"
      },
    marko_attrs22 = {
        "class": "col"
      },
    marko_attrs23 = {
        "class": "form-group"
      },
    marko_attrs24 = {
        "class": "col-md-6 col-12 form-group"
      },
    marko_attrs25 = {
        "class": "col form-group"
      },
    marko_attrs26 = {
        "class": "mb-4"
      },
    marko_attrs27 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs28 = {
        "for": "by-packages",
        "class": "font-medium-1"
      },
    marko_attrs29 = {
        href: "/user/subscription"
      },
    marko_node4 = marko_createElement("br", null, "65", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs30 = {
        "class": "list-inline m-0"
      },
    marko_attrs31 = {
        "class": "mr-2"
      },
    marko_attrs32 = {
        "class": "chip theme-bg-lighten rounded"
      },
    marko_attrs33 = {
        "class": "chip-body font-medium-2"
      },
    marko_attrs34 = {
        "class": "chip-text py-50"
      },
    marko_attrs35 = {
        "class": "chip-closeable p-50 m-50"
      },
    marko_attrs36 = {
        "class": "bx bx-x white-text"
      },
    marko_attrs37 = {
        "class": "col"
      },
    marko_attrs38 = {
        "class": "col text-right"
      },
    marko_attrs39 = {
        "class": "btn btn-secondary"
      },
    marko_attrs40 = {
        "class": "accordion collapse-icon accordion-icon-rotate",
        id: "course-details",
        "data-toggle-hover": "true"
      },
    marko_attrs41 = {
        "class": "mt-2"
      },
    marko_attrs42 = {
        "class": "py-1"
      },
    marko_attrs43 = {
        "class": "font-medium-2"
      },
    marko_attrs44 = {
        "class": "position-relative form-group"
      },
    marko_node5 = marko_createElement("br", null, "118", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("br", null, "128", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("br", null, "129", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node8 = marko_createElement("br", null, "130", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs45 = {
        "class": "col"
      },
    marko_attrs46 = {
        "class": "col text-right"
      },
    marko_attrs47 = {
        "class": "btn btn-secondary"
      },
    marko_attrs48 = {
        "class": "pl-50"
      },
    marko_attrs49 = {
        "class": "d-inline-flex align-items-center border p-1 mr-2 mb-2",
        style: "border-radius:4px"
      },
    marko_attrs50 = {
        "class": "pl-50"
      },
    marko_node9 = marko_createElement("br", null, "107", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs51 = {
        "class": "list-inline"
      },
    marko_attrs52 = {
        "class": "mr-2"
      },
    marko_attrs53 = {
        "class": "chip pl-0 theme-bg-lighten round"
      },
    marko_attrs54 = {
        "class": "chip-body font-medium-2 d-flex align-items-center"
      },
    marko_attrs55 = {
        style: "width:35px;height:35px;margin-left:3px"
      },
    marko_attrs56 = {
        "class": "chip-text pl-75 py-50"
      },
    marko_attrs57 = {
        "class": "chip-closeable p-50 m-50"
      },
    marko_attrs58 = {
        "class": "bx bx-x white-text"
      },
    marko_attrs59 = {
        "class": "col-md-4 col-6 pr-50"
      },
    marko_attrs60 = {
        type: "reset",
        "class": "btn btn-light btn-xl w-100"
      },
    marko_attrs61 = {
        "class": "col pl-50"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out, { themeMode }) {
        if (state.course === null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (state.course === false) {
          EmptyList_tag({
              message: "The page you are trying to access is nowhere to be found",
              routeTo: "courses"
            }, out, __component, "2");
        } else {
          out.be("form", marko_attrs0, "@edit-course", component);

          WSAdapt_tag({
              ns: "col-md-5 col-12",
              hs: "col-12",
              class: "col",
              renderBody: function(out) {
                Row_tag({
                    renderBody: function(out) {
                      out.be("div", marko_attrs8, "5", component);

                      PosterInput_tag({
                          src: state.form.poster,
                          style: "height:12rem",
                          btn: Locale("Change Poster")
                        }, out, __component, "6", [
                        [
                          "click",
                          "onSelectPoster",
                          false,
                          [
                              true
                            ]
                        ]
                      ]);

                      out.ee();

                      out.be("div", marko_attrs9, "7", component);

                      out.be("div", marko_attrs10, "8", component);

                      out.e("input", {
                          type: "text",
                          value: state.form.name,
                          name: "name",
                          "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.name != undefined ? state.formError.name ? " is-invalid" : " is-valid" : "")),
                          validate: "required",
                          placeholder: Locale("Course Name*")
                        }, "9", component, 0, 0, {
                          onchange: __component.d("change", "__onChange", false)
                        });

                      out.be("p", {
                          "class": marko_classValue("small mt-50 mb-2" + (!state.formError.name ? " d-none" : ""))
                        }, "10", component, null, 1);

                      Locale_tag({
                          text: "Course name is required"
                        }, out, __component, "11");

                      out.ee();

                      out.ee();

                      out.be("div", marko_attrs11, "12", component);

                      out.be("p", marko_attrs12, "13", component);

                      Locale_tag({
                          text: "Course Categories"
                        }, out, __component, "14");

                      out.ee();

                      out.be("ul", marko_attrs13, "15", component);

                      if (state.form.categories) {
                        marko_forOf(state.form.categories, function({ categoryId, name }, index) {
                          var $keyValue$0 = "@" + ("cat-" + index),
                              $keyScope$0 = "[" + ($keyValue$0 + "]");

                          out.e("li", marko_attrs14, $keyValue$0, component, 1)
                            .e("div", marko_attrs15, "16" + $keyScope$0, component, 1)
                              .e("div", marko_attrs16, "17" + $keyScope$0, component, 2)
                                .e("span", marko_attrs17, "18" + $keyScope$0, component, 1)
                                  .t(name, component)
                                .e("div", marko_attrs18, "19" + $keyScope$0, component, 1, 0, {
                                    onclick: __component.d("click", "removeCategory", false, [
                                        categoryId
                                      ])
                                  })
                                  .e("i", marko_attrs19, "20" + $keyScope$0, component, 0);
                        });
                      }

                      out.be("li", null, "21", component);

                      SelectCategory_tag({
                          add: true,
                          label: "Select",
                          btnType: "btn-secondary"
                        }, out, __component, "22", [
                        [
                          "add",
                          () => navigate('/categories'),
                          false
                        ],
                        [
                          "select",
                          "addCategory",
                          false
                        ]
                      ]);

                      out.ee();

                      out.ee();

                      out.ee();

                      out.ee();
                    }
                  }, out, __component, "4");

                out.n(marko_node0, component);

                Row_tag({
                    renderBody: function(out) {
                      out.be("div", marko_attrs20, "25", component);

                      out.be("div", marko_attrs21, "26", component);

                      out.e("input", {
                          type: "text",
                          value: state.form.code,
                          name: "code",
                          "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.code != undefined ? state.formError.code ? " is-invalid" : " is-valid" : "")),
                          validate: "required",
                          placeholder: Locale("Course Code")
                        }, "27", component, 0, 0, {
                          onchange: __component.d("change", "__onChange", false)
                        });

                      out.be("p", {
                          "class": marko_classValue("small mt-50 mb-2" + (!state.formError.code ? " d-none" : ""))
                        }, "28", component, null, 1);

                      Locale_tag({
                          text: "Invalid course code"
                        }, out, __component, "29");

                      out.ee();

                      out.ee();

                      out.ee();

                      out.e("div", marko_attrs22, "30", component, 1)
                        .e("div", marko_attrs23, "31", component, 1)
                          .e("input", {
                              type: "number",
                              value: state.form.points,
                              name: "points",
                              "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.points != undefined ? state.formError.points ? " is-invalid" : " is-valid" : "")),
                              placeholder: Locale("Points Eg. 100, 300")
                            }, "32", component, 0, 0, {
                              onchange: __component.d("change", "__onChange", false)
                            });
                    }
                  }, out, __component, "24");

                out.e("div", marko_attrs1, "33", component, 1)
                  .e("textarea", {
                      type: "text",
                      value: state.form.description,
                      name: "description",
                      "class": marko_classValue("form-control form-control-xl pl-4 " + (state.formError.description != null ? state.formError.description ? " is-invalid" : " is-valid" : "")),
                      placeholder: Locale("Description*"),
                      validate: "required",
                      style: marko_styleValue({
                          height: "100px",
                          resize: "none"
                        })
                    }, "34", component, 0, 0, {
                      onchange: __component.d("change", "__onChange", false)
                    });

                Row_tag({
                    renderBody: function(out) {
                      out.be("div", marko_attrs24, "36", component);

                      Select_tag({
                          class: "rounded",
                          size: "xl",
                          value: state.form.availability,
                          name: "availability",
                          options: [
                              {
                                  value: "public",
                                  label: "Public"
                                },
                              {
                                  value: "private",
                                  label: "Private"
                                },
                              {
                                  value: "restricted",
                                  label: "Restricted"
                                }
                            ],
                          placeholder: Locale("Availability*")
                        }, out, __component, "37", [
                        [
                          "select",
                          "__onChange",
                          false
                        ]
                      ]);

                      out.ee();

                      out.be("div", marko_attrs25, "38", component);

                      Select_tag({
                          class: "rounded",
                          size: "xl",
                          value: state.form.difficultyLevel,
                          name: "difficultyLevel",
                          options: [
                              {
                                  value: "beginner",
                                  label: "Beginner"
                                },
                              {
                                  value: "intermediate",
                                  label: "Intermediate"
                                },
                              {
                                  value: "advanced",
                                  label: "Advanced"
                                }
                            ],
                          placeholder: Locale("Difficulty Level*")
                        }, out, __component, "39", [
                        [
                          "select",
                          "__onChange",
                          false
                        ]
                      ]);

                      out.ee();
                    }
                  }, out, __component, "35");

                out.be("div", marko_attrs2, "40", component);

                PriceInput_tag({
                    size: "xl",
                    name: "price",
                    value: state.form.price,
                    placeholder: Locale("Price")
                  }, out, __component, "41", [
                  [
                    "change",
                    "__onChange",
                    false
                  ]
                ]);

                out.ee();

                out.n(marko_node1, component);

                out.be("div", marko_attrs3, "43", component);

                out.be("div", marko_attrs4, "44", component);

                _preserve_tag({
                    n: true,
                    renderBody: function(out) {
                      out.e("input", {
                          type: "checkbox",
                          id: "multi-language",
                          name: "multiLanguage",
                          checked: state.form.multiLanguage
                        }, "45", component, 0, 0, {
                          onchange: __component.d("change", "__onChecked", false)
                        });
                    }
                  }, out, __component, "45");

                out.be("label", marko_attrs5, "46", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Multi-Language Support");
                    }
                  }, out, __component, "47");

                out.t(" ");

                out.be("a", marko_attrs6, "48", component);

                Locale_tag({
                    text: "Learn more"
                  }, out, __component, "49");

                out.ee();

                out.ee();

                out.ee();

                out.ee();

                if (((state.tenant.settings.pricing && state.tenant.settings.pricing) && state.tenant.settings.pricing.learner) && state.tenant.settings.pricing.learner.enabled) {
                  out.be("div", marko_attrs26, "50", component);

                  out.be("div", marko_attrs27, "51", component);

                  _preserve_tag({
                      n: true,
                      renderBody: function(out) {
                        out.e("input", {
                            type: "checkbox",
                            id: "by-packages",
                            name: "byPackages",
                            checked: state.byPackages
                          }, "52", component, 0, 0, {
                            onchange: __component.d("change", "onByPackages", false)
                          });
                      }
                    }, out, __component, "52");

                  out.be("label", marko_attrs28, "53", component);

                  Locale_tag({
                      renderBody: function(out) {
                        out.t("Offer course by subscription packages");
                      }
                    }, out, __component, "54");

                  out.t(" ");

                  out.be("a", marko_attrs29, "55", component);

                  Locale_tag({
                      text: "Learn more"
                    }, out, __component, "56");

                  out.ee();

                  out.ee();

                  out.ee();

                  out.ee();

                  if (state.byPackages) {
                    out.be("ul", marko_attrs30, "57", component);

                    marko_forOf(state.form.packages, function(each, index) {
                      var $keyValue$1 = "@" + ("cat-" + index),
                          $keyScope$1 = "[" + ($keyValue$1 + "]");

                      out.e("li", marko_attrs31, $keyValue$1, component, 1)
                        .e("div", marko_attrs32, "58" + $keyScope$1, component, 1)
                          .e("div", marko_attrs33, "59" + $keyScope$1, component, 2)
                            .e("span", marko_attrs34, "60" + $keyScope$1, component, 1)
                              .t(each.toCapitalCase(), component)
                            .e("div", marko_attrs35, "61" + $keyScope$1, component, 1, 0, {
                                onclick: __component.d("click", "removePackage", false, [
                                    each
                                  ])
                              })
                              .e("i", marko_attrs36, "62" + $keyScope$1, component, 0);
                    });

                    out.be("li", null, "63", component);

                    SelectPackage_tag({
                        accountType: "learner",
                        selectAll: true,
                        label: "Select Package",
                        btnType: "btn-secondary"
                      }, out, __component, "64", [
                      [
                        "select",
                        "addPackage",
                        false
                      ],
                      [
                        "select-all",
                        "addAllPackage",
                        false
                      ]
                    ]);

                    out.ee();

                    out.ee();
                  }

                  out.n(marko_node4, component);
                }

                out.be("div", marko_attrs7, "66", component);

                Row_tag({
                    class: "d-flex align-items-center",
                    renderBody: function(out) {
                      out.be("div", marko_attrs37, "68", component);

                      out.be("h5", null, "69", component);

                      Locale_tag({
                          text: "Schedules",
                          class: "font-medium-3"
                        }, out, __component, "70");

                      out.ee();

                      out.ee();

                      out.be("div", marko_attrs38, "71", component);

                      out.be("button", marko_attrs39, "72", component, null, 0, {
                          onclick: __component.d("click", "onModalForm", false, [
                              "Schedule",
                              true
                            ])
                        });

                      Locale_tag({
                          text: "Add"
                        }, out, __component, "73");

                      out.t("/");

                      Locale_tag({
                          text: "Edit"
                        }, out, __component, "74");

                      out.ee();

                      out.ee();
                    }
                  }, out, __component, "67");

                Schedules_tag({
                    list: state.form.schedules,
                    removable: true
                  }, out, __component, "75", [
                  [
                    "remove",
                    "removeSchedule",
                    false
                  ]
                ]);

                out.ee();

                out.n(marko_node2, component);

                out.n(marko_node3, component);
              }
            }, out, __component, "3");

          WSAdapt_tag({
              hs: "col-12",
              class: "col pt-0",
              renderBody: function(out) {
                out.be("div", marko_attrs40, "79", component);

                Card_Accordion_tag({
                    target: "course-about-content",
                    title: "Course About",
                    icon: "bx-info-circle",
                    borderStyle: true,
                    renderBody: function(out) {
                      QuillEditor_tag({
                          value: state.form.about,
                          toolbar: [
                              "list",
                              "align",
                              "embed-block",
                              "latex"
                            ],
                          name: "about",
                          height: "300px",
                          author: getFullname(state.user),
                          noReturnWordsCount: true
                        }, out, __component, "81", [
                        [
                          "change",
                          "__onChange",
                          false
                        ]
                      ]);
                    }
                  }, out, __component, "80");

                Card_Accordion_tag({
                    target: "course-objectives",
                    title: "Course Objectives",
                    icon: "bx-list-check",
                    borderStyle: true,
                    renderBody: function(out) {
                      QuillEditor_tag({
                          value: state.form.objectives,
                          toolbar: [
                              "align",
                              "list"
                            ],
                          name: "objectives",
                          maxlength: 1000,
                          author: getFullname(state.user),
                          noReturnWordsCount: true
                        }, out, __component, "83", [
                        [
                          "change",
                          "__onChange",
                          false
                        ]
                      ]);
                    }
                  }, out, __component, "82");

                Card_Accordion_tag({
                    target: "course-policy",
                    title: "Course Policy",
                    icon: "bx-copyright",
                    borderStyle: true,
                    renderBody: function(out) {
                      QuillEditor_tag({
                          value: state.form.policy,
                          toolbar: [
                              "align",
                              "list"
                            ],
                          name: "policy",
                          maxlength: 1000,
                          author: getFullname(state.user),
                          noReturnWordsCount: true
                        }, out, __component, "85", [
                        [
                          "change",
                          "__onChange",
                          false
                        ]
                      ]);
                    }
                  }, out, __component, "84");

                Card_Accordion_tag({
                    target: "course-readings",
                    title: "Course Readings",
                    icon: "bx-book-content",
                    borderStyle: true,
                    renderBody: function(out) {
                      QuillEditor_tag({
                          value: state.form.readings,
                          name: "readings",
                          maxlength: 1000,
                          author: getFullname(state.user),
                          noReturnWordsCount: true
                        }, out, __component, "87", [
                        [
                          "change",
                          "__onChange",
                          false
                        ]
                      ]);
                    }
                  }, out, __component, "86");

                out.ee();

                out.be("div", marko_attrs41, "88", component);

                Row_tag({
                    class: "d-flex align-items-center",
                    renderBody: function(out) {
                      out.be("div", marko_attrs45, "90", component);

                      out.be("h5", null, "91", component);

                      Locale_tag({
                          text: "Prerequisites",
                          class: "font-medium-3"
                        }, out, __component, "92");

                      out.ee();

                      out.ee();

                      out.be("div", marko_attrs46, "93", component);

                      out.be("button", marko_attrs47, "94", component, null, 0, {
                          onclick: __component.d("click", "onModalForm", false, [
                              "Prerequisite",
                              true
                            ])
                        });

                      Locale_tag({
                          text: "Add"
                        }, out, __component, "95");

                      out.t("/");

                      Locale_tag({
                          text: "Edit"
                        }, out, __component, "96");

                      out.ee();

                      out.ee();
                    }
                  }, out, __component, "89");

                out.be("div", marko_attrs42, "97", component);

                var $for$0 = 0;

                marko_forOf(state.form.prerequisites, function({ label, link }, index) {
                  var $keyScope$2 = "[" + (($for$0++) + "]");

                  if (link) {
                    out.be("a", {
                        type: "button",
                        "class": "d-inline-flex align-items-center border p-1 mr-2 mb-2",
                        href: link,
                        target: "_blank",
                        style: "border-radius:4px"
                      }, "@" + index, component);

                    Locale_tag({
                        text: label
                      }, out, __component, "98" + $keyScope$2);

                    out.be("span", marko_attrs48, "99" + $keyScope$2, component, null, 0, {
                        onclick: __component.d("click", "removePrerequisite", false, [
                            index
                          ])
                      });

                    Bx_tag({
                        type: "x",
                        class: "p-25 round theme-bg-lighten"
                      }, out, __component, "100" + $keyScope$2);

                    out.ee();

                    out.ee();
                  } else {
                    out.be("div", marko_attrs49, "@" + index, component);

                    Locale_tag({
                        text: label
                      }, out, __component, "101" + $keyScope$2);

                    out.be("span", marko_attrs50, "102" + $keyScope$2, component, null, 0, {
                        onclick: __component.d("click", "removePrerequisite", false, [
                            index
                          ])
                      });

                    Bx_tag({
                        type: "x",
                        class: "p-25 round theme-bg-lighten"
                      }, out, __component, "103" + $keyScope$2);

                    out.ee();

                    out.ee();
                  }
                });

                out.ee();

                out.ee();

                out.be("div", null, "104", component);

                out.be("p", marko_attrs43, "105", component);

                Locale_tag({
                    text: "Add Instructors"
                  }, out, __component, "106");

                out.ee();

                if (Array.isArray(state.form.instructors) && state.form.instructors.length) {
                  out.n(marko_node9, component);

                  out.be("ul", marko_attrs51, "108", component);

                  marko_forOf(state.form.instructors, function({ photo, title, name, email }, index) {
                    var $keyValue$2 = "@" + ("inst-" + index),
                        $keyScope$3 = "[" + ($keyValue$2 + "]");

                    out.be("li", marko_attrs52, $keyValue$2, component);

                    out.be("div", marko_attrs53, "109" + $keyScope$3, component);

                    out.be("div", marko_attrs54, "110" + $keyScope$3, component);

                    out.be("div", marko_attrs55, "111" + $keyScope$3, component);

                    Image_tag({
                        alt: "avatar",
                        src: photo,
                        class: "img-fluid rounded-circle"
                      }, out, __component, "112" + $keyScope$3);

                    out.ee();

                    out.e("span", marko_attrs56, "113" + $keyScope$3, component, 3)
                      .t(title, component)
                      .t(" ")
                      .t(name, component);

                    out.e("div", marko_attrs57, "114" + $keyScope$3, component, 1, 0, {
                        onclick: __component.d("click", "removeInstructor", false, [
                            email
                          ])
                      })
                      .e("i", marko_attrs58, "115" + $keyScope$3, component, 0);

                    out.ee();

                    out.ee();

                    out.ee();
                  });

                  out.ee();
                }

                out.be("div", marko_attrs44, "116", component);

                SearchBar_tag({
                    size: "xl",
                    icon: "bx-user",
                    target: "user",
                    minLength: 3,
                    filters: {
                        type: "learner"
                      },
                    suggestions: state.suggestions,
                    alternatives: [
                        {
                            href: "/add-user",
                            icon: "bx-user",
                            title: Locale("Invite an instructor")
                          }
                      ],
                    placeholder: Locale("Find instructor by name, email, ...")
                  }, out, __component, "117", [
                  [
                    "blur",
                    "onSearchDismiss",
                    false
                  ],
                  [
                    "result",
                    "onSearchResult",
                    false
                  ],
                  [
                    "dismiss",
                    "onSearchDismiss",
                    false
                  ],
                  [
                    "select",
                    "onSelectSuggestion",
                    false
                  ],
                  [
                    "select-alt",
                    "onSelectSuggestionAlt",
                    false
                  ]
                ]);

                out.ee();

                out.ee();

                out.n(marko_node5, component);

                FormAlert_tag({
                    alert: state.alert
                  }, out, __component, "119");

                Row_tag({
                    renderBody: function(out) {
                      out.be("div", marko_attrs59, "121", component);

                      out.be("button", marko_attrs60, "122", component, null, 0, {
                          onclick: __component.d("click", "onCancel", false)
                        });

                      Locale_tag({
                          text: "Cancel"
                        }, out, __component, "123");

                      out.ee();

                      out.ee();

                      out.be("div", marko_attrs61, "124", component);

                      out.be("button", {
                          type: "submit",
                          "class": "btn btn-primary btn-xl w-100",
                          disabled: state.submitting
                        }, "125", component, null, 0, {
                          onclick: __component.d("click", "onSubmit", false)
                        });

                      Preloader_tag({
                          class: "float-right font-medium-5",
                          active: state.submitting
                        }, out, __component, "126");

                      Locale_tag({
                          text: "Save"
                        }, out, __component, "127");

                      out.ee();

                      out.ee();
                    }
                  }, out, __component, "120");

                out.n(marko_node6, component);

                out.n(marko_node7, component);

                out.n(marko_node8, component);
              }
            }, out, __component, "78");

          out.ee();

          if (state.showPrerequisiteForm) {
            PrerequisiteForm_tag({
                for: "course",
                prerequisites: state.form.prerequisites
              }, out, __component, "131", [
              [
                "done",
                value => component.fhandler.set( 'prerequisites', value ),
                false
              ],
              [
                "dismiss",
                "onModalForm",
                false,
                [
                    "Prerequisite",
                    false
                  ]
              ]
            ]);
          }

          if (state.showScheduleForm) {
            ScheduleForm_tag({
                for: "course",
                schedules: state.form.schedules
              }, out, __component, "132", [
              [
                "done",
                value => component.fhandler.set( 'schedules', value ),
                false
              ],
              [
                "dismiss",
                "onModalForm",
                false,
                [
                    "Schedule",
                    false
                  ]
              ]
            ]);
          }

          if (state.showPosterPlus == true) {
            PosterPlus_tag({
                cdn: "course",
                width: 440,
                height: 280,
                maxSize: 1024,
                accepts: "image/*",
                theme: themeMode,
                adaptive: true
              }, out, __component, "133", [
              [
                "done",
                "onSetPoster",
                false
              ],
              [
                "cancelled",
                "onSelectPoster",
                false,
                [
                    false
                  ]
              ]
            ]);
          }
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
